import React from "react";
import { Helmet } from "react-helmet-async";
import ParticlesBackground from "./ParticlesBackground";
import "./Serviceshero.css";
import DesignImage from "./images/Software-IT-Services-Transparent-PNG.png";

const ServicesHero = ({ isDarkMode }) => {
  return (
    <>
      <Helmet>
        <title>Web Design, SEO & Cybersecurity in Nairobi - AstraSight</title>
        <meta
          name="description"
          content="Expert Web Design, SEO, and Cybersecurity services in Nairobi, Kenya. Elevate your digital presence with AstraSight Technologies."
        />
        <meta
          name="keywords"
          content="Web Design Nairobi, SEO Services Kenya, Cybersecurity Africa, AstraSight Technologies"
        />
        <meta name="author" content="AstraSight Technologies" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "AstraSight Technologies",
            url: "https://astrasighttech.com",
            logo: "https://astrasighttech.com/images/asighticon1.png",
            description:
              "Providing Web Design, SEO, and Cybersecurity services in Nairobi, Kenya, and across Africa.",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Nairobi",
              addressCountry: "KE",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+254791865638",
              contactType: "customer service",
            },
          })}
        </script>
      </Helmet>

      <section className={`heroabout ${isDarkMode ? "dark" : "light"}`}>
        {/* 🌐 PARTICLES (shared background – same as AboutHero) */}
        <ParticlesBackground isDarkMode={isDarkMode} />

        <div className="heroabout-content">
<div className="content-left">
  <div className="text-container with-line">
    <h1 className="about-heading service">Our Services</h1>
    <p className="about-paragraph">
      We design, secure, and grow your digital presence. From{" "}
      <strong>website development</strong> to{" "}
      <strong>SEO optimization</strong> and{" "}
      <strong>cybersecurity solutions</strong>, let’s elevate your
      business together!
    </p>
  </div>
</div>


          <div className="image-container">
            <img
              className="about-image"
              src={DesignImage}
              alt="AstraSight Technologies - Web Design, SEO, and Cybersecurity Services in Nairobi, Kenya"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesHero;
